export default __webpack_public_path__ + "static/media/home_connect_power.0568daaa.svg";